import { adminApi } from "./api-admin";
import { dashboardApi } from "./api-dashboard";
import { evalsApi } from "./api-evals";
import { playgroundApi } from "./api-playground";
import { promptsApi } from "./api-prompts";
import { socialApi } from "./api-social";
import { tovApi } from "./api-tov";

export const api = {
  ...dashboardApi,
  ...adminApi,
  tov: tovApi,
  evals: evalsApi,
  playground: playgroundApi,
  prompts: promptsApi,
  social: socialApi,
};
